import { _callAuthenticatedAPI } from '../apiCaller';
import { HTTPMethod } from 'src/enums/request';
import {
    AppInstallationRequest,
    GetUsersRequest,
    GetGithubAppUrl,
    CreateProjectRequest
} from 'src/types/onboarding';
import { UpdateProjectRequest } from 'src/types/projects';
export function createProject(params: CreateProjectRequest): Promise<any> {
    let endpointUrl = `backend/api/v1/dashboards/project`;
    const res = _callAuthenticatedAPI(endpointUrl, HTTPMethod.POST, params);
    return res;
}

export function getGithubAppUrl(params: GetGithubAppUrl): Promise<any> {
    let endpointUrl = `backend/api/v1/dashboards/github-url/${params.projectId}`;
    const res = _callAuthenticatedAPI(endpointUrl, HTTPMethod.GET);
    return res;
}

export function appInstallationCallback(
    params: AppInstallationRequest
): Promise<any> {
    let endpointUrl = `robobee/api/github/v1/auth/callback/${params.code}/${params.installation_id}/${params.state}`;
    const res = _callAuthenticatedAPI(endpointUrl, HTTPMethod.GET);
    return res;
}

export function getUsers(params: GetUsersRequest): Promise<any> {
    let endpointUrl = `backend/api/v1/dashboards/users?query=${params.query}`;
    const res = _callAuthenticatedAPI(endpointUrl, HTTPMethod.GET);
    return res;
}

export function updateProject(params: UpdateProjectRequest): Promise<any> {
    let endpointUrl = `backend/api/v1/dashboards/project`;
    const res = _callAuthenticatedAPI(endpointUrl, HTTPMethod.PUT, params);
    return res;
}

export function getSkills(): Promise<any> {
    let endpointUrl = 'backend/api/v1/skill';
    return _callAuthenticatedAPI(endpointUrl);
}
